module.exports = __webpack_public_path__ + "static/media/avatar.658dbf7d.svg";